<template>
  <div class="language-switcher">
    <button class="current-language" @click="toggleDropdown">
      <img :src="currentLang.flag" :alt="currentLang.name" class="flag-icon" />
    </button>

    <ul v-if="dropdownOpen" class="language-menu">
      <li
        v-for="lang in languages"
        class="language-option"
        @click="changeLanguage(lang.code)"
        :key="lang.code"
      >
        <img :src="lang.flag" :alt="lang.name" class="flag-icon" />
        {{ lang.name }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

// Import des drapeaux PNG
import frFlag from '@/assets/fr.png'
import usFlag from '@/assets/us.png'

const { locale } = useI18n()
const dropdownOpen = ref(false)

const languages = [
  { code: 'fr', name: 'Français', flag: frFlag },
  { code: 'en', name: 'English', flag: usFlag }
]

const currentLang = computed(() => {
  return languages.find(lang => lang.code === locale.value) || languages[0]
})

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value
}

const changeLanguage = (code: string) => {
  locale.value = code
  localStorage.setItem('locale', code)
  dropdownOpen.value = false
}
</script>

<style scoped>
.language-switcher {
  position: relative;
  display: inline-flex;
  align-items: center;
  user-select: none;
}

.current-language {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px; /* Match nav-link height */
  line-height: 24px; /* Ensure vertical centering */
}

.flag-icon {
  width: 24px;
  height: 16px;
  object-fit: contain;
  border-radius: 2px;
  vertical-align: middle; /* Additional alignment fix */
}

.language-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  list-style: none;
  padding: 4px 0;
  margin: 0;
  min-width: 120px;
  z-index: 100;
}

.language-option {
  padding: 6px 12px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-option:hover {
  background-color: #0097a7;
}
</style>